export const GET_FACILITY_PENDING = "GET_FACILITY_PENDING";
export const GET_MORE_FACILITY_PENDING = "GET_MORE_FACILITY_PENDING";
export const GET_FACILITY_SUCCESS = "GET_FACILITY_SUCCESS";
export const GET_MORE_FACILITY_SUCCESS = "GET_MORE_FACILITY_SUCCESS";
export const RESET_FACILITY = "RESET_FACILITY";
